import {Component, ViewChild} from '@angular/core';
import {
    ChartComponent
} from 'ng-apexcharts';
import {DocumentListingFacade} from '../store/document-listing.facade';
import {DocumentViewVariantEnum} from '../store/document-listing.reducers';

@Component({
    selector: 'app-document-margin-chart-view',
    templateUrl: './document-margin-chart-view.component.html',
    styleUrl: './document-margin-chart-view.component.scss'
})
export class DocumentMarginChartViewComponent {
    public activeView$ = this._documentListingFacade.activeView$; // 'folder_view', 'chart_view', 'margin_chat_view'
    @ViewChild('chart') chart: ChartComponent;
    public marginSignedDocChart;
    public marginActiveDocChart;
    public marginSignedDocuments;
    public basedOnSignedDateChart;
    public sentDateForActive;
    public marginOverTimeChart;

    constructor(
        private _documentListingFacade: DocumentListingFacade,
    ) {

        //document margin Signed chart
        this.marginSignedDocChart = {
            series: [44, 55, 13, 43],
            chart: {
                width: '100%',
                type: 'pie'
            },
            labels: ['Cost', 'Price', 'Margin'],
            theme: {
                monochrome: {
                    enabled: true
                }
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                fontFamily: 'Montserrat", Helvetica, Arial, serif',
                fontWeight: 400,
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'middle',
                offsetX: 0,
                style: {
                    fontSize: '12px',
                    fontFamily: 'Montserrat", Helvetica, Arial, serif',
                    fontWeight: 'bold'
                },
                dropShadow: {
                    enabled: false,
                    top: 1,
                    left: 1,
                    blur: 1,
                    color: '#000',
                    opacity: 0.45
                }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }
            ]
        };

        //document contract attention chart
        this.marginActiveDocChart = {
            series: [44, 55, 13],
            chart: {
                width: '100%',
                type: 'pie'
            },
            labels: ['Cost', 'Price', 'Margin'],
            theme: {
                monochrome: {
                    enabled: true
                }
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                fontFamily: 'Montserrat", Helvetica, Arial, serif',
                fontWeight: 400,
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'middle',
                offsetX: 0,
                style: {
                    fontSize: '12px',
                    fontFamily: 'Montserrat", Helvetica, Arial, serif',
                    fontWeight: 'bold'
                },
                dropShadow: {
                    enabled: false,
                    top: 1,
                    left: 1,
                    blur: 1,
                    color: '#000',
                    opacity: 0.45
                }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }
            ]
        };

        //margin Signed Documents chart
        this.marginSignedDocuments = {
            marginSignedDocumentsseries: [
                {
                    name: 'Margin',
                    data: [44, 55,]
                },
                {
                    name: 'Price',
                    data: [53, 32]
                },
                {
                    name: 'Cost',
                    data: [12, 17]
                }
            ],
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: '20%',
                }
            },
            dataLabels: {
                enabled: false,
                formatter: (val) => {
                    return Number(val) / 1000 + '';
                }
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            xaxis: {
                categories: ['mubashir', 'fahad'],
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                        color: '#6e6b7b'
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + 'K';
                    }
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                fontFamily: 'Montserrat", Helvetica, Arial, serif',
                fontWeight: 400,
            },
        };

        //based On Signed Date chart
        this.basedOnSignedDateChart = {
            basedOnSignedDateChartseries: [
                {
                    name: 'Margin',
                    data: [44, 55,]
                },
                {
                    name: 'Price',
                    data: [53, 32]
                },
                {
                    name: 'Cost',
                    data: [12, 17]
                }
            ],
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: '20%',
                }
            },
            dataLabels: {
                enabled: false,
                formatter: (val) => {
                    return Number(val) / 1000 + '';
                }
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            xaxis: {
                categories: ['mubashir', 'fahad'],
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                        color: '#6e6b7b'
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + 'K';
                    }
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                fontFamily: 'Montserrat", Helvetica, Arial, serif',
                fontWeight: 400,
            },
        };

        //based On sent Date For Active chart
        this.sentDateForActive = {
            sentDateForActiveseries: [
                {
                    name: 'Margin',
                    data: [44, 55,]
                },
                {
                    name: 'Price',
                    data: [53, 32]
                },
                {
                    name: 'Cost',
                    data: [12, 17]
                }
            ],
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: '20%',
                }
            },
            dataLabels: {
                enabled: false,
                formatter: (val) => {
                    return Number(val) / 1000 + '';
                }
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            xaxis: {
                categories: ['mubashir', 'fahad'],
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                        color: '#6e6b7b'
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + 'K';
                    }
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                fontFamily: 'Montserrat", Helvetica, Arial, serif',
                fontWeight: 400,
            },
        };

        //Sent & Accepted margin Over Time chart
        const allMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        this.marginOverTimeChart = {
            seriesOverTime: [
                {
                    name: 'Cost',
                    data: [5, 5, 10, 8, 7, 5, 4, 10, 10, 7, 8, 6, 9]
                },
                {
                    name: 'Margin',
                    data: [
                        10,
                        15,
                        12,
                        10,
                        12,
                        15,
                        12,
                        14,
                    ]
                },
                {
                    name: 'Price',
                    data: [
                        10,
                        15,
                        12,
                        10,
                        12,
                        15,
                        12,
                        14,
                    ]
                }
            ],
            chart: {
                height: 350,
                type: 'line',
                toolbar: {
                    show: false
                },
                animations: {
                    enabled: false
                }
            },
            yaxis: {
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                    },
                },
            },
            xaxis: {
                categories: allMonths,
                labels: {
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Montserrat", Helvetica, Arial, serif',
                        fontWeight: 400,
                    },
                },
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                fontSize: '12px',
                fontFamily: 'Montserrat", Helvetica, Arial, serif',
                fontWeight: 400,
            },
            stroke: {
                curve: 'straight',
                width: 2,
            },
            labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        };
    }

    /**
     * Toggle view behalf on view key
     * @param view
     */
    toggleViews(view: DocumentViewVariantEnum) {
        this._documentListingFacade.changeActiveView(view);
    }
}
